export default [
  {
    title: 'Dashboard',
    key: 'dashboard',
    icon: 'icmn icmn-stack',
    url: '/',
  },

  {
    title: 'Home',
    key: 'home',
    icon: 'icmn icmn-home',
    url: 'https://adbility-media.com/',
  },

  {
    title: 'Contact',
    key: 'contact',
    icon: 'icmn icmn-quill',
    url: 'https://www.adbility-media.com/kontakt/',
  },

  {
    title: 'Logout',
    key: 'logout',
    icon: 'icmn icmn-exit',
    url: '/logout',
  },
]



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/menuData.js